module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="nav-bar">\n    <div class="' +
__e( newDashboardExperience ? "fastr-frontend-logo-container" : "logo-container" ) +
'">\n        <a href="' +
__e( newDashboardExperience ? config.contentControlUrl : "#" ) +
'" class="logo"></a>\n    </div>\n    ';
 if (!newDashboardExperience) { ;
__p += '\n        <div class="project-buttons-container">\n            <div class="project-selector-btn';
 if (currentProject) { ;
__p += ' in-project-context';
 } ;
__p += '">\n                <div class="project-btn-icon"></div>\n                <div class="project-btn-txt">Projects</div>\n            </div>\n            ';
 if (currentProject) { ;
__p += '\n                <a class="project-context-btn" href="#project/' +
__e( currentProjectId ) +
'" title="' +
__e( currentProjectName ) +
'">' +
__e( currentProjectName ) +
'</a>\n            ';
 } ;
__p += '\n        </div>\n    ';
 } ;
__p += '\n    <div class="editor-nav-bar">\n        ';
 if (!group) { ;
__p += '\n        <span class="name-container">\n            <span class="experience-name name-input tour-experience-name" contenteditable="' +
__e( spectator ? "false" : "true" ) +
'"></span>\n        </span>\n        ';
 } ;
__p += '\n            <div class="variants-region"></div>\n            <div id ="c3CollectionsWrapper">\n                <div id="c3collections" class ="c3collection-region"></div>\n            </div>\n        ';
 if(!newDashboardExperience) { ;
__p += '\n            <div class="create-new-variant dropdown ' +
__e( spectator ? " disabled" : "" ) +
'">\n                <a href="#" class="dropdown-toggle' +
__e( spectator ? " disabled" : "" ) +
'" data-toggle="dropdown" ' +
__e( spectator ? " disabled" : "" ) +
'>Variants</a>\n                <ul class="new-variant-ul">\n                    <li class="create-new-locale-variant"></li>\n                    <li class="add-breakpoint-variant' +
__e( canConvertToGroup ? "": " disabled" ) +
'">Breakpoint Variant</li>\n                </ul>\n            </div>\n        ';
 } ;
__p += '\n    </div>\n    <div class="spacer"></div>\n    <div class="spinner" data-spinner-color="#000" data-spinner-size="20">\n        <div class="ladda-label"></div>\n    </div>\n    <div class="current-principal"></div>\n</div>\n\n<div class="experience-options-panel"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/EditorNavBarView.tpl
// module id = 2955
// module chunks = 0